import React, { Component } from 'react';
import {connect} from 'react-redux';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import ReactTable from "react-table";
import AddNewVATGroupChild from './AddNewVATGroupChild'
import Underscore from 'underscore';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import NoData from '../page/NoData';
import Pagination from '../page/Pagination'
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';

const log = new Logger('VAT_GROUPS_DETAILS', LOG_LEVELS.DEBUG);


class VATGroupDetails extends Component {
    constructor(props) {
        super(props);
        this.deleteClickHandler = this.deleteClickHandler.bind(this);
    }
    deleteClickHandler(cellInfo) {
        log.debug('deleteClickHandler ', cellInfo);
        if (window.confirm('Are you sure you wish to delete this item?')) {
            log.debug('deleteClickHandler ', cellInfo.companyCode,cellInfo.companyId);
            this.props.deleteChildVATGroupHandler(cellInfo.companyId);
        }
    }

    addChildVATGroup(parentCompanyId,childCompanyIds)
    {
        log.debug('addChildVATGroup ', parentCompanyId,childCompanyIds);
        this.props.addChildVATGroupHandler(parentCompanyId, childCompanyIds);
    }
    render() {
        log.debug('VATGroups ', this.props.vatGroupList);


        const columns = [
        {
            expander: true,
            Header: () => <span></span>,
            width: 65,
            Expander: ({ isExpanded, ...rest }) =>
                <s-icon name="chevron-down"></s-icon>,
            style: {
                cursor: "pointer",
                padding: "0",
                textAlign: "center",
                userSelect: "none"
            }
        },{
            Header: props => <span><LanguageStringResolver string='vatGroups_Code'/></span>,
            accessor: 'companyCode',
            filterable: true
        },{
            Header: props => <span><LanguageStringResolver string='vatGroups_CompanyName'/></span>,
            accessor: 'companyName',
            filterable: true
        }, {
            Cell: ({ original }) => {
              return (
                <ReadOnlyWrapper>
                  <button onClick={(e) => { this.deleteClickHandler(original); }} className="link delete pad-right-sm">
                    <LanguageStringResolver string='vatGroups_Delete'/>
                  </button>
                </ReadOnlyWrapper>
              );
            },
            Header: props => <span><LanguageStringResolver string='vatGroups_Actions'/></span>,
            className: 'text-align-right',
            sortable: false
          }]
        log.debug('render(): ', this.props);

        const NoDataComponent = props => (
            <NoData
              noDataText="VATGroups_NoData"
              {...props}
            />
          )

        return (
            <div>
                <ReactTable
                    defaultPageSize={20}
                    minRows={0}
                    maxRows={0}
                    data={this.props.vatGroupList}
                    columns={columns}
                    SubComponent={row => {
                        log.debug('row ', row, row.original.childCompanies);
                        return (

                            <div className="reactTable-expand-container">
                                <s-container>
                                    <h2>VAT Group  - {row.original.companyCode}</h2>
                                    <div className="mt15 mb15">

                                        {
                                            (() => {
                                                if (row.original.childCompanies.length <=0 ) {
                                                    return (<div>No child found</div>)
                                                }

                                                return  row.original.childCompanies.map((child) => {
                                                    var childCompanyList = Underscore.map(child.childCompanies,function(item){ return item['companyId']});
                                                    var siblingCompanyList = Underscore.map(row.original.childCompanies,function(item){ return item['companyId']});
                                                    log.debug('tempVATGroupData ', childCompanyList);
                                                    log.debug('siblingCompanyList ', siblingCompanyList);
                                                    log.debug('parent id' ,row.original.companyId,child)
                                                    return(
                                                        <div>
                                                            <ul className="vat-groups">

                                                                <li><span className="large node-heading">{"(" + child.companyCode + ") - " + child.companyName}</span>
                                                                    <AddNewVATGroupChild
                                                                        companyId={child.companyId}
                                                                        addChildVATGroupHandler={this.addChildVATGroup.bind(this)}
                                                                        childCompanyList={childCompanyList}
                                                                        siblingCompanyList={siblingCompanyList}
                                                                        parentCompanyId={row.original.companyId}
                                                                    /></li>
                                                                { (() => {

                                                                    if(child.childCompanies !== undefined && child.childCompanies.length > 0)
                                                                    {
                                                                        return  child.childCompanies.map((grandChild) => {
                                                                            var grandchildCompanyList = Underscore.map(grandChild.childCompanies,function(item){ return item['companyId']});
                                                                            var childSiblingCompanyList = Underscore.map(child.childCompanies,function(item){ return item['companyId']});

                                                                            log.debug('tempVATGroupData ', grandchildCompanyList);
                                                                            log.debug('parent id' ,grandChild.companyId,child.childCompanies)
                                                                            return(
                                                                                <ul>
                                                                                    <li><span className="large node-heading">{"(" + grandChild.companyCode + ") - " + grandChild.companyName}</span>
                                                                                        <AddNewVATGroupChild
                                                                                            companyId={grandChild.companyId}
                                                                                            addChildVATGroupHandler={this.addChildVATGroup.bind(this)}
                                                                                            childCompanyList={grandchildCompanyList}
                                                                                            siblingCompanyList={childSiblingCompanyList}
                                                                                            parentCompanyId={child.companyId}
                                                                                        /></li>
                                                                                </ul>
                                                                            )
                                                                        })
                                                                    }
                                                                })()
                                                                }

                                                            </ul>
                                                        </div>
                                                    );
                                                })
                                            })()

                                        }
                                        <ul className="vat-groups pt10 pb10 pl15">
                                            <li className="add-new">
                                                <AddNewVATGroupChild
                                                    companyId={row.original.companyId}
                                                    addChildVATGroupHandler={this.addChildVATGroup.bind(this)}
                                                    childCompanyList={Underscore.map(row.original.childCompanies,function(item){ return item['companyId']})}
                                                />
                                            </li>
                                        </ul>
                                    </div>
                                </s-container>
                            </div>

                        );
                    }}
                    NoDataComponent={NoDataComponent}
                    className={this.props.vatGroupList <= 0 ? 'hide-header' : ''}
                    PaginationComponent={Pagination}
                    showPagination={this.props.vatGroupList <= 0 ? false : true}
                />

            </div>
        )
    }
}






function mapStateToProps(state) {
    log.debug('mapStateToProps: ', state);
    return {
        companyList: (state.companies && state.companies.data) || []
    };
}


export default connect(mapStateToProps)(VATGroupDetails);
